import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddServiceTimingsComponent } from "src/app/shared/components/add-service-timings/add-service-timings.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";
import { MeetingDataComponent } from "../new-v2-component/meeting-data/meeting-data.component";

@Component({
  selector: "sm-new-service-hours",
  templateUrl: "./new-service-hours.component.html",
  styleUrls: ["./new-service-hours.component.scss"],
})
export class NewServiceHoursComponent implements OnInit, OnDestroy {
  hidediv: boolean = false
  loader: boolean = false;
  apisub: Subscription
  businessListData: any[] = []
  serviceTimings: any[] = []
  finalServiceTimings: any[] = []
  selectedBusiness:any
  selectedServiceType: any = '1'
  groupedServiceTimings:any = null
  toShowTimings: boolean = false
  daysOfWeek = [
    { day: 1, name: 'Sunday' },
    { day: 2, name: 'Monday' },
    { day: 3, name: 'Tuesday' },
    { day: 4, name: 'Wednesday' },
    { day: 5, name: 'Thursday' },
    { day: 6, name: 'Friday' },
    { day: 7, name: 'Saturday' }
  ];
  isEmployeeAndHasBusinessButDoesNotHaveAccess:boolean = false
  constructor(
    private apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private navservice: NavigationService,
    private router: Router,
    private _modelRef: MatDialog,
    private dialog:MatDialog,
    private route:ActivatedRoute,
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST){
        
          this.businessListData = []
          if(resdata.result){
            this.businessListData = resdata.result
            let checkForAccessLength = this.businessListData.length
            this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0 // Add the isSelected property
            }))
            .filter((element: any) => 
              (element.is_owner == 1 )|| (
                element.entitySubscriptionInfo && 
                element.entitySubscriptionInfo !== 'null' &&
                element.employeeSubscriptionInfo &&
                element.employeeSubscriptionInfo !== 'null' && element.employee_status == 1 )
            );
            if(checkForAccessLength - this.businessListData.length > 0){
              this.isEmployeeAndHasBusinessButDoesNotHaveAccess = true
            }  
            if(this.businessListData.length > 0){
              this.businessListData[0].isSelected = 1
              this.selectedBusiness = this.businessListData[0]
              localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,this.selectedBusiness.entity_public_hash_id)

            }
            console.log('bl',this.selectedBusiness);
            
            }
            if(this.businessListData.length > 0){
              if(this.selectedServiceType == '0'){
                this.apiservice.getHomeServiceTimeDetails(this.selectedBusiness.hashId)
              }
              else if(this.selectedServiceType == '1'){
                this.apiservice.getShopEntityTimeDetails(this.selectedBusiness.hashId)
              }
              
            }
            else{
              this.loaderservice.showLoader = false
              this.loader = false

            }
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_HOME_SERVICE_TIMINGS){
        this.serviceTimings = []
        this.groupedServiceTimings = null
        this.toShowTimings = false
        if(resdata.result){
          resdata.result.forEach((element:any) => {
            element.timeList = JSON.parse(element.timeList)
          });

          console.log(resdata.result);

        resdata.result.forEach((element:any) => {
          if(element.timeList.length > 1){
            element.timeList.forEach((childItem:any, index:number) => {
              childItem.toShowType = index == 0 ? 'parent' : 'child'
              childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
              childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
              this.serviceTimings.push(childItem)
            });
          }else{
            element.timeList[0].toShowType = 'parent'
            element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
            element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
            this.serviceTimings.push(element.timeList[0])
          }
          
        });

        console.log(this.serviceTimings);
        
        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
          let dayFound = false; // Flag to keep track if the day was found in serviceTimings
        
          for (let j = 0; j < this.serviceTimings.length; j++) {
            if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
              this.serviceTimings[j].status = 1;
              this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
              this.finalServiceTimings.push(this.serviceTimings[j]);
              dayFound = true;
            }
          }
        
          if (!dayFound) {
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
          }
        }
        console.log(this.finalServiceTimings);
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.toShowTimings = true
       }
       else{
        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
          // let dayFound = false; 
          // for (let j = 0; j < this.serviceTimings.length; j++) {
          //   if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
          //     this.serviceTimings[j].status = 1;
          //     this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
          //     this.finalServiceTimings.push(this.serviceTimings[j]);
          //     dayFound = true;
          //   }
          // }
        
         
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
        
        }
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.toShowTimings = false
       }
       
       
       this.loaderservice.showLoader = false
       this.loader = false
       this.hidediv = false
      }
      else if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_SHOP_SERVICE_TIMINGS){
        this.serviceTimings = []
        this.groupedServiceTimings = null
        this.toShowTimings = false
        if(resdata.result){
          resdata.result.forEach((element:any) => {
            element.timeList = JSON.parse(element.timeList)
          });

          console.log(resdata.result);

        resdata.result.forEach((element:any) => {
          if(element.timeList.length > 1){
            element.timeList.forEach((childItem:any, index:number) => {
              childItem.toShowType = index == 0 ? 'parent' : 'child'
              childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
              childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
              this.serviceTimings.push(childItem)
            });
          }else{
            element.timeList[0].toShowType = 'parent'
            element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
            element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
            this.serviceTimings.push(element.timeList[0])
          }
          
        });

        console.log(this.serviceTimings);
        
        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
          let dayFound = false; // Flag to keep track if the day was found in serviceTimings
        
          for (let j = 0; j < this.serviceTimings.length; j++) {
            if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
              this.serviceTimings[j].status = 1;
              this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
              this.finalServiceTimings.push(this.serviceTimings[j]);
              dayFound = true;
            }
          }
        
          if (!dayFound) {
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
          }
        }
        console.log(this.finalServiceTimings);
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.toShowTimings = true
       }
       else{

        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
        
        
         
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
        
        }
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.toShowTimings = false
       }
       this.loaderservice.showLoader = false
       this.loader = false
       this.hidediv = false
      }
      else if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_VIRTUAL_SERVICE_TIMINGS){
        this.serviceTimings = []
        this.groupedServiceTimings = null
        this.toShowTimings = false
        if(resdata.result){
          let formattedData = this.formatTimeDataForVirtual(resdata.result)
          // resdata.result.forEach((element:any) => {
          //   element.timeList = JSON.parse(element.timeList)
          // });

          console.log(resdata.result);

          formattedData.forEach((element:any) => {
          if(element.timeList.length > 1){
            element.timeList.forEach((childItem:any, index:number) => {
              childItem.toShowType = index == 0 ? 'parent' : 'child'
              childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
              childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
              this.serviceTimings.push(childItem)
            });
          }else{
            element.timeList[0].toShowType = 'parent'
            element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
            element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
            this.serviceTimings.push(element.timeList[0])
          }
          
        });

        console.log(this.serviceTimings);
        
        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
          let dayFound = false; // Flag to keep track if the day was found in serviceTimings
        
          for (let j = 0; j < this.serviceTimings.length; j++) {
            if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
              this.serviceTimings[j].status = 1;
              this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
              this.finalServiceTimings.push(this.serviceTimings[j]);
              dayFound = true;
            }
          }
        
          if (!dayFound) {
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
          }
        }
        console.log(this.finalServiceTimings);
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.toShowTimings = true
       }
       else{

        this.finalServiceTimings = []
        for (let index = 0; index < this.daysOfWeek.length; index++) {
        
        
         
            let data = {
              day: this.daysOfWeek[index].day,
              dayName: this.daysOfWeek[index].name,
              hashId: null,
              openTime: '---',
              closeTime: '---',
              operationDate: null,
              specialDayStatus: null,
              toShowType: 'parent',
              status: 0
            };
            this.finalServiceTimings.push(data);
        
        }
        this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
        this.toShowTimings = false
       }
       this.loaderservice.showLoader = false
       this.loader = false
       this.hidediv = false
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS
      ) {
        if (resdata.result) {
          if(this.selectedServiceType == '0'){
            this.apiservice.getHomeServiceTimeDetails(this.selectedBusiness.hashId)
          }
          else if(this.selectedServiceType == '1'){
            this.apiservice.getShopEntityTimeDetails(this.selectedBusiness.hashId)
          }
          else if(this.selectedServiceType == '2'){
            this.apiservice.getVirtualServiceTimings(this.selectedBusiness.entity_public_hash_id)
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS
      ) {
        if (resdata.result) {
          if(this.selectedServiceType == '0'){
            this.apiservice.getHomeServiceTimeDetails(this.selectedBusiness.hashId)
          }
          else if(this.selectedServiceType == '1'){
            this.apiservice.getShopEntityTimeDetails(this.selectedBusiness.hashId)
          }
          else if(this.selectedServiceType == '2'){
            this.apiservice.getVirtualServiceTimings(this.selectedBusiness.entity_public_hash_id)
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_VIRTUAL_SERVICE_TIMINGS
      ) {
        if (resdata.result) {
          if(this.selectedServiceType == '0'){
            this.apiservice.getHomeServiceTimeDetails(this.selectedBusiness.hashId)
          }
          else if(this.selectedServiceType == '1'){
            this.apiservice.getShopEntityTimeDetails(this.selectedBusiness.hashId)
          }
          else if(this.selectedServiceType == '2'){
            this.apiservice.getVirtualServiceTimings(this.selectedBusiness.entity_public_hash_id)
          }
        }
      }
    })
  }

  selectcountry(){
    let dialogref = this.dialog.open(SelectBusinessCountryComponent,{
    width:'500px',
    disableClose:true,
    data:{
      link:"",
      title: 'Select business country',
      ref: this.dialog
    }})
    dialogref.afterClosed().subscribe(res => {
      if(res){
        this.router.navigate(['purchased-plan']);
      }
    } 
    )
    }
  ngOnInit(): void {
    // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH);
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.apiservice.getBasicEntityList();
  }
  createNewBusiness(){

    this.router.navigate(['purchased-plan']);
}
changeTimingsViewStatus(){
  this.toShowTimings = true
}
  onSelectChange(event:any){
      this.loaderservice.showLoader = true
      this.hidediv = true
      console.log(event.value);
      if(event.value == '0'){
        this.apiservice.getHomeServiceTimeDetails(this.selectedBusiness.hashId)
      }
      else if(event.value == '1'){
        this.apiservice.getShopEntityTimeDetails(this.selectedBusiness.hashId)
      }
      else if(event.value == '2'){
        this.apiservice.getVirtualServiceTimings(this.selectedBusiness.entity_public_hash_id)
      }

  }
 
  //   "day",
  //   "session",
  //   "startTime",
  //   "stopTime",
  //   "actions",
  // ];
  // sessions = [
  //   {
  //     day: "Sunday",
  //     session: "1",
  //     startTime: "9:00 AM",
  //     stopTime: "02:00 PM",
  //     rowspan: 1,
  //     showDay: true,
  //   },
  //   {
  //     day: "",
  //     session: "2",
  //     startTime: "10:00 AM",
  //     stopTime: "11:00 PM",
  //     rowspan: 1,
  //     showDay: false,
  //   },
  //   // Add more session objects as needed
  //   {
  //     day: "Monday",
  //     session: "1",
  //     startTime: "9:00 AM",
  //     stopTime: "10:00 AM",
  //     rowspan: 1,
  //     showDay: true,
  //   },
  //   {
  //     day: "",
  //     session: "2",
  //     startTime: "10:00 AM",
  //     stopTime: "11:00 AM",
  //     rowspan: 1,
  //     showDay: false,
  //   },
  //   {
  //     day: "Tuesday",
  //     session: "1",
  //     startTime: "9:00 AM",
  //     stopTime: "11:00 PM",
  //     rowspan: 1,
  //     showDay: true,
  //   },
  //   {
  //     day: "Wednesday",
  //     session: "1",
  //     startTime: "9:00 AM",
  //     stopTime: "11:00 PM",
  //     rowspan: 1,
  //     showDay: true,
  //   },
  //   {
  //     day: "Thursday",
  //     session: "1",
  //     startTime: "9:00 AM",
  //     stopTime: "10:00 AM",
  //     rowspan: 1,
  //     showDay: true,
  //   },
  //   {
  //     day: "Friday",
  //     session: "1",
  //     startTime: "9:00 AM",
  //     stopTime: "10:00 AM",
  //     rowspan: 1,
  //     showDay: true,
  //   },
  //   {
  //     day: "Saturday",
  //     session: "1",
  //     startTime: "9:00 AM",
  //     stopTime: "10:00 AM",
  //     rowspan: 1,
  //     showDay: true,
  //   },
  // ];
  openAddTime(rowvalue:any){
    rowvalue.serviceType = this.selectedServiceType
    rowvalue.entityHash = this.selectedBusiness.hash_id
    let dialogref = this._modelRef.open(AddServiceTimingsComponent, {
      width: '500px',
      data: {
        title: 'Add service timing',
        ref: this._modelRef,
        data: rowvalue
      },
    });
    dialogref.afterClosed().subscribe(res =>{
      if(res){
        if(this.selectedServiceType == '0'){
          this.apiservice.getHomeServiceTimeDetails(this.selectedBusiness.hashId)
        }
        else if(this.selectedServiceType == '1'){
          this.apiservice.getShopEntityTimeDetails(this.selectedBusiness.hashId)
        }
        else if(this.selectedServiceType == '2'){
          this.apiservice.getVirtualServiceTimings(this.selectedBusiness.entity_public_hash_id)
        }
      }
    })
  }

  removeTime(rowvalue:any){
    if(this.selectedServiceType == '0'){
      let data = {
        homeServiceTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this.loaderservice.showLoader = true
      this.apiservice.updateHomeServiceTimeInfo(
        this.selectedBusiness.hash_id,
        data
      );
    }
    else if(this.selectedServiceType == '1'){
      let data = {
        entityTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this.loaderservice.showLoader = true
      this.apiservice.updateEntityShopTimeInfo(
        this.selectedBusiness.hash_id,
        data
      );
    }
    else if(this.selectedServiceType == '2'){
      let data = 
      {
        "entityHash": this.selectedBusiness.hash_id,
        "timeList": [
            {
                "hashId": rowvalue.hashId,
                "status": "2"
               
            }
        ]
    }

      this.loaderservice.showLoader = true
      this.apiservice.updateVirtualServiceTimingInfo(
        data
      );
    }
  }
  selectBusiness(index:any){
    this.businessListData.forEach((element:any) => {
      element.isSelected = 0
    });
    this.businessListData[index].isSelected = 1
    this.selectedBusiness = this.businessListData[index]
    localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,this.selectedBusiness.entity_public_hash_id)
    this.hidediv = true
    this.loaderservice.showLoader = true
    if(this.selectedBusiness.shop_service_status != 2){
      this.selectedServiceType = '1'
      this.apiservice.getShopEntityTimeDetails(this.selectedBusiness.hashId)
    }
    else if(this.selectedBusiness.home_service_status != 2){
      this.selectedServiceType = '0'
      this.apiservice.getHomeServiceTimeDetails(this.selectedBusiness.hashId)
    }
     
    else if(this.selectedBusiness.virtual_service_status != 2){
      this.selectedServiceType = '2'
      this.apiservice.getVirtualServiceTimings(this.selectedBusiness.entity_public_hash_id)
    }
    // if(this.selectedServiceType == '0'){
    //   this.apiservice.getHomeServiceTimeDetails(this.selectedBusiness.hashId)
    // }
    // else if(this.selectedServiceType == '1'){

    // }
    // else if(this.selectedServiceType == '2'){
    //   this.apiservice.getVirtualServiceTimings(this.selectedBusiness.entity_public_hash_id)
    // }
  }  

  convertTo12HourFormat(timeString:any) {
    
    const [hours, minutes] = timeString.split(':');
    let period = 'AM';
    let hour = parseInt(hours, 10);
  
    if (hour >= 12) {
      period = 'PM';
      if (hour > 12) {
        hour -= 12;
      }
    }
  
    return `${hour.toString().padStart(2, '0')}:${minutes} ${period}`;
  }
  groupBy(array: any, key: any) {
  // Step 1: Group the input array by the specified key
  const grouped = array.reduce((acc:any, curr:any) => {
    if (!acc[curr[key]]) {
      acc[curr[key]] = [];
    }
    acc[curr[key]].push(curr);
    return acc;
  }, {});

  // Step 2: Transform the grouped object into an array of objects with timelist
  return Object.values(grouped).map(timelist => ({ timelist }));
  }

ngOnDestroy(): void {
  this.apisub.unsubscribe()
}


openvideo(){
  this.dialog.open(YoutubeEmbedVideoComponent,{
  width:'1000px',
  disableClose:true,
  data:{
    link:"https://www.youtube.com/embed/PGWMD0qBbzo?si=ph8Gw-2kAVQN8evr",
    title: 'Setting Business Hours in LookzUp Web Portal.'
  }})
  }

  opencontact(){
    this.router.navigate(['/contact-us']);
  }

  formatTimeData(data: any) {
    const groupedData: { [key: number]: any } = {};
  
    data.forEach((item:any) => {
      const formattedItem = {
        day: item.day,
        hashId: item.hash_id,
        openTime: `${item.open_time}.000000`,
        closeTime: `${item.close_time}.000000`,
        operationDate: null,
        specialDayStatus: item.special_day_status
      };
  
      if (!groupedData[item.day]) {
        groupedData[item.day] = { timeList: [formattedItem] };
      } else {
        groupedData[item.day].timeList.push(formattedItem);
      }
    });
  
    return Object.values(groupedData);
  }
  formatTimeDataForVirtual(data: any) {
    const groupedData: { [key: number]: any } = {};
  
    data.forEach((item:any) => {
      const formattedItem = {
        day: item.day,
        hashId: item.hash_id,
        openTime: `${item.open_time}.000000`,
        closeTime: `${item.close_time}.000000`,
        operationDate: null,
        specialDayStatus: item.special_day_status,
        meeting_details: item.meeting_details ? (typeof item.meeting_details == 'string' ? JSON.parse(item.meeting_details) : item.meeting_details) : null
      };
  
      if (!groupedData[item.day]) {
        groupedData[item.day] = { timeList: [formattedItem] };
      } else {
        groupedData[item.day].timeList.push(formattedItem);
      }
    });
  
    return Object.values(groupedData);
  }
  
  openLink(url: string): void {
    window.open(url, "_blank");
  }

  configureUnavailability(){
    // this.snackBar.open("Coming soon in next version.", "Ok", {
    //   duration: 5000,
    //   horizontalPosition: "center",
    //   verticalPosition: "bottom",
    // });
    // ?serviceType=2&entityHash=dc9c361261775779d463ccd9889602b66b135f48
    this.router.navigate(['unavailability'],{queryParams:{ serviceType:this.selectedServiceType, entityHash: this.selectedBusiness.hash_id }, relativeTo:this.route})
  }

  openAddEditMeetingDetails(item:any){
    let dialogref = this.dialog.open(MeetingDataComponent,{
      width: '500px',
      data:{
        data: item,
        isOwner: this.selectedBusiness.is_owner
      }
    })
    dialogref.afterClosed().subscribe(data => {
      if(data){
        this.apiservice.getVirtualServiceTimings(this.selectedBusiness.entity_public_hash_id)
      }
    })
  }

}
